<template>
    <div class="animated fadeIn">
        <vue-loading :active="isLoading" loader="bars" :is-full-page="false"></vue-loading>
        <b-form>
            <b-form-group
                    description="Enter name."
                    label="Person Name"
                    :label-cols="3"
                    :horizontal="true">
                <b-form-input  type="text" v-model="user.name"></b-form-input>
            </b-form-group>
            <b-form-group
                    description="Enter surname."
                    label="Person Surname"
                    :label-cols="3"
                    :horizontal="true">
                <b-form-input  type="text" v-model="user.surname"></b-form-input>
            </b-form-group>
          <b-form-group
            v-if="!addOption"
            description="Status"
            label="User Status"
            :label-cols="3"
            :horizontal="true"
          >
            <app-btn :text="user.status"></app-btn>
          </b-form-group>
            <b-form-group
                    description="Enter Email."
                    label="Person Email"
                    :label-cols="3"
                    :horizontal="true">
                <b-form-input  type="email" v-model="user.email"></b-form-input>
            </b-form-group>
            <b-form-group
                    v-if="addOption"
                    description="Enter Password."
                    label="Person Password"
                    :label-cols="3"
                    :horizontal="true">
                <b-form-input  type="password" v-model="user.password"></b-form-input>
            </b-form-group>
            <div slot="footer">
              <user-add-button
                v-if="addOption"
                :user="user"
                @click="onClick"
              ></user-add-button>
              <user-update-button
                v-if="!addOption"
                :user="user"
                @click="onClick"
                @change="onSaveUser"
              ></user-update-button>
              <user-suspend-button
                v-if="!addOption && editOption"
                :user="user"
                @click="onClick"
                @suspend="onSuspendedUser"
              ></user-suspend-button>
              <user-activate-button
                v-if="!addOption && editOption"
                :user="user"
                @click="onClick"
                @active="onUserActivated"
              ></user-activate-button>
            </div>
        </b-form>
    </div>
</template>
<script>
    import VueLoading from "vue-loading-overlay/src/js/Component";
    import {User} from "../../models/User";
    import AppBtn from "../base/AppBtn";
    import UserSuspendButton from "./buttons/UserSuspendButton";
    import UserActivateButton from "./buttons/UserActivateButton";
    import UserAddButton from "./buttons/UserAddButton";
    import UserUpdateButton from "./buttons/UserUpdateButton";

    export default {
        name: 'user-form',
        components: {
            UserUpdateButton,
            UserAddButton,
            UserActivateButton,
            UserSuspendButton,
            AppBtn,
            VueLoading,
        },
        props: {
            user: {
                type: Object,
                default: new User(),
            },
            addOption: {
                type: Boolean,
                default: false,
            },
            editOption: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                isLoading: false,
            }
        },
        methods: {
            onSaveUser(user) {
                this.isLoading = false,
                this.user = user,
                this.flash('User has been updated', 'success')
            },
            onSuspendedUser(user) {
                this.isLoading = false
                this.user = user
                this.flash('User has been suspended', 'success')
            },
            onUserActivated(user) {
                this.isLoading = false,
                this.flash('User has been activated', 'success'),
                this.user = user
            },
            onClick(){
                this.isLoading = true
            },
        }
    }
</script>
